module.exports = __webpack_public_path__ + "static/media/HT-PG.06dfb6f7.pdf";